import {AuditLogModel} from '../security/audit/audit-logs/state/audit-log.model';

export class AuditData {

  theList: AuditLogModel[] = [];
  nextToken: string;
  queryTime: number;

}
